import { render, staticRenderFns } from "./Mesoregion.vue?vue&type=template&id=0927b57f&"
import script from "./Mesoregion.vue?vue&type=script&lang=ts&"
export * from "./Mesoregion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports